import { Injectable } from "@angular/core";
import { IBooleanInputTranslations } from "../../tcm-core.module/interfaces/boolean-input-translation.inerface";
import { ISelectInputTranslations } from "../../tcm-core.module/interfaces/select-Input-Translations.interface";

export abstract class TranslationProvider {
  abstract getWeekdayShortName(weekday: number): string;
  abstract getMonthFullName(month: number): string;
  abstract getMonthShortName(month: number): string;
  abstract getSelectInputTranslations(): ISelectInputTranslations;
  abstract getBooleanInputTranslations(): IBooleanInputTranslations;
}

export interface WafSelectInputTranslations {
  NoResultsFound: string;
  EnterCharacters: string;
  Enter2OrMoreCharacters: any;
  Enter1OrMoreCharacters: any;
}

export interface WafBooleanInputTranslations {
  Yes: string;
  No: string;
  Either: string;
}

const WEEKDAYS_SHORT = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
const MONTHS_FULL = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const MONTHS_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const SELECT_INPUT_TRANSLATIONS: WafSelectInputTranslations = {
  NoResultsFound: "No results found",
  EnterCharacters: "Please enter characters",
  Enter2OrMoreCharacters: "Please enter 2 or more characters",
  Enter1OrMoreCharacters: "Please enter 1 or more characters",
};
const BOOLEAN_INPUT_TRANSLATIONS: WafBooleanInputTranslations = {
  Yes: "Yes",
  No: "No",
  Either: "Either",
};

@Injectable()
export class EnglishTranslationProvider extends TranslationProvider {
  getWeekdayShortName(weekday: number): string {
    return WEEKDAYS_SHORT[weekday - 1];
  }

  getMonthFullName(month: number): string {
    return MONTHS_FULL[month - 1];
  }

  getMonthShortName(month: number): string {
    return MONTHS_SHORT[month - 1];
  }

  getSelectInputTranslations(): WafSelectInputTranslations {
    return SELECT_INPUT_TRANSLATIONS;
  }

  getBooleanInputTranslations(): WafBooleanInputTranslations {
    return BOOLEAN_INPUT_TRANSLATIONS;
  }
}

